import { createContext, useContext } from 'react';
var BaseButtonContext = /*#__PURE__*/createContext({
  isIconButton: false,
  variant: 'primary',
  size: 'small'
});

var useBaseButtonContext = function useBaseButtonContext() {
  return useContext(BaseButtonContext);
};

export { BaseButtonContext, useBaseButtonContext };